import type {
  AnnotationDocument,
  AnnotationItem,
  AnnotationPosition,
  ModelCoordinateMetadata,
  SpatialCompatibility,
} from "@factory-twin/contracts";

export function emptyAnnotationDocument(sceneId: string, model: ModelCoordinateMetadata): AnnotationDocument {
  return {
    version: "1.1",
    sceneId,
    modelVersion: model.modelVersion,
    coordinateFrameId: model.coordinateFrameId,
    coordinateConvention: model.coordinateConvention,
    annotations: [],
  };
}

export function compatibleSpatialDocument(): SpatialCompatibility {
  return { status: "COMPATIBLE", reason: null, suggestedTransformAvailable: false, transformConfidence: null };
}

export function isAnnotationDisplaySafe(compatibility: SpatialCompatibility): boolean {
  return compatibility.status === "COMPATIBLE";
}

export function addAnnotation(document: AnnotationDocument, position: AnnotationPosition): AnnotationDocument {
  const annotation: AnnotationItem = {
    id: crypto.randomUUID(),
    position,
    title: "新しい注釈",
    content: "",
    category: "safety",
  };
  return { ...document, annotations: [...document.annotations, annotation] };
}

export function reanchorAnnotation(document: AnnotationDocument, annotation: AnnotationItem, position: AnnotationPosition): AnnotationDocument {
  return { ...document, annotations: [...document.annotations, { ...annotation, position }] };
}

export function updateAnnotation(document: AnnotationDocument, annotation: AnnotationItem): AnnotationDocument {
  return {
    ...document,
    annotations: document.annotations.map((item) => item.id === annotation.id ? annotation : item),
  };
}

export function deleteAnnotation(document: AnnotationDocument, annotationId: string): AnnotationDocument {
  return { ...document, annotations: document.annotations.filter((item) => item.id !== annotationId) };
}

export function downloadAnnotationJson(annotationDocument: AnnotationDocument): void {
  const blob = new Blob([JSON.stringify(annotationDocument, null, 2)], { type: "application/json" });
  const anchor = document.createElement("a");
  anchor.href = URL.createObjectURL(blob);
  anchor.download = `Annotation-${annotationDocument.sceneId}.json`;
  anchor.click();
  URL.revokeObjectURL(anchor.href);
}
